var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.showPaymentModal)?_c('PaymentModal',{attrs:{"formActionUrl":_vm.formActionUrl},on:{"close":_vm.closeModal}}):_vm._e(),_vm._v(" "),_c('div',{ref:"paymentScriptWrapper"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }